
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import { Translate, I18n } from 'react-redux-i18n';

class UploadFilesComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: '',
      name: '',
      show: false,
      success: '',
      message: '',
    };
  }

  sendFile = async (file) => {
    try {
      await this.props.sendFile(file);
      await this.setState({ message: '', success: I18n.t('successFile') });
    } catch (err) {
      if (err.response && err.response.data.error.code === 850) {
        this.setState({ message: I18n.t('permissionErrorText1'), success: '' });
      } else if (err.response && err.response.data.error.code === 851) {
        this.setState({ message: I18n.t('permissionErrorText2'), success: '' });
      } else if (err.response && err.response.data.error.code === 852) {
        this.setState({ message: I18n.t('permissionErrorText3'), success: '' });
      } else if (err.response && err.response.data.error.code === 853) {
        this.setState({ message: I18n.t('permissionErrorText4'), success: '' });
      } else if (err.response && err.response.data.error.code === 304) {
        this.setState({ message: I18n.t('categoryAlreadyExists'), success: '' });
      } else if (err.response && err.response.data.error.code === 305) {
        this.setState({ message: I18n.t('categoryParentNotFound'), success: '' });
      } else {
        await this.setState(
          { message: I18n.t('invalidCsvFile'), success: '' },
        );
      }
    }
  }

  uploadedFile(files) {
    this.setState({
      name: files[0].name, show: true, file: files[0], success: '', message: '',
    });
  }

  render() {
    const {
      name, show, file, success, message,
    } = this.state;
    const { itemsErrors, importMessage = '' } = this.props;

    return (
      <React.Fragment>
        <div className="row">
          <button
            type="button"
            onClick={() => this.props.goBack()}
            className="btn btn-warning margin-right-15"
          >
            <Translate value="return" />
          </button>
          <button
            type="button"
            onClick={() => this.props.modelDownload()}
            className="btn btn-warning promotion-btn-warning"
          >
            <Translate value="importModel" />
          </button>
        </div>
        <Dropzone
          onDrop={acceptedFiles => this.uploadedFile(acceptedFiles)}
        >
          {({ getRootProps, getInputProps }) => (
            <section className="main-drop-down-files">
              <div className="drag-and-drop-container">
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  <h5><Translate value="dragAndDrop" /></h5>
                </div>

                {show && (
                  <div>
                    <br />
                    <p className="text-align-center">{name}</p>
                    <br />
                    <button
                      type="button"
                      onClick={() => this.sendFile(file)}
                      className="btn btn-dark upload-file-btn"
                    >
                      <Translate value="send" />
                    </button>
                  </div>
                )}

                <br />
                {success && <p className="color-green text-align-center margin-top-10">{success}</p>}
                <br />
                {message && <p className="color-red text-align-center margin-top-10">{message}</p>}

                {importMessage && <p className="color-green text-align-center">{importMessage}</p>}

                {itemsErrors}

              </div>
            </section>
          )}
        </Dropzone>
      </React.Fragment>
    );
  }
}

export default UploadFilesComponent;
